import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const doctorAgendaLocaleModule: LocaleModule = {
  name: "doctorAgenda",
  messages: { en: en, it: it },
};
